import { type RedeemCopyType } from '@/features/purchase/services/GiftCard/types'

export const isValidRedeemType = (redeemType: string): redeemType is RedeemCopyType =>
  ['credit', 'membership'].indexOf(redeemType) > -1

export const isValidZip = (zip: number | string) => {
  const zipPattern = /^\d{5}(-\d{4})?$/
  return zipPattern.test(String(zip))
}

export const isValidUuidFormat = (uuid: string) => {
  // Note: the `uuid` library validation requires compliance with RFC 4122 and UUIDs
  // generated for universal products in production do not always meet this requirement
  const regex =
    /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/
  return regex.test(uuid)
}
